import appConstants from '../../../../../../../../constants';
import { KEYS } from '../../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../../utils/computeClassName';
import { useL18nContext } from '../../../../../../ContextProvider/L18n';
import { useScreenContext } from '../../../../../../ContextProvider/Screen';
import { useUserContext } from '../../../../../../ContextProvider/User';
import {useNotificationsContext} from '../../../../../../ContextProvider/Notifications';
import { usePartnerSearchContext } from '../../../../../../ContextProvider/Partner/Search';
import { useNavigationBetweenPartnerListsContext } from '../../../../../../ContextProvider/Navigation/BetweenPartnerLists';
import FormsControlBar from '../../FormsControlBar';
import CCTab from '../../../../../../../libs/CiscoCore/Tab';
import SortingParameter from './SortingParameter';
import navigateToURL from '../../../../../../../../utils/navigateToURL';

const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-primary 2xs:bg-transparent shadow-cc-lg 2xs:shadow-none'
});

function getComputedTabSize(useLargeTab) {
  return useLargeTab ? 'large':'medium';
}

export default function ResultTabs( { className } ) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { isScreen2XSAndUp, isScreenSMAndUp } = useScreenContext();
  const useLargeTab = isScreenSMAndUp;
  const useShortLabels = !isScreen2XSAndUp;
  const computedTabSize = getComputedTabSize(useLargeTab);

  const { getTranslationFor } = useL18nContext();
  const translatedAllResultsLabel = useShortLabels?getTranslationFor(KEYS.L18N_KEY_LABEL_ALL):getTranslationFor(KEYS.L18N_KEY_LABEL_ALL_RESULTS);
  const translatedSavedLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_SAVED);
  const translatedMyPartnersLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_MY_PARTNERS);

  const {
    user,
    isLoggedInUserFetchingInProgress,
    loggedInUserFetchingError,
    userSavedPartners
  } = useUserContext();

  const {
    foundPartnerCount,
    toggleFilters,
    persistAppState,
  } = usePartnerSearchContext();

  const {
    activateFoundPartners,
    isFoundPartnersActive,
    activateSavedPartners,
    isSavedPartnersActive,
    activateMyPartners,
    isMyPartnersActive
  } = useNavigationBetweenPartnerListsContext();

  const {
    notifyMustLogInFn
  } = useNotificationsContext();

  function beforeLogin() {
    persistAppState();
    navigateToURL(appConstants.SSO_LOGIN_URL);
  }

  const computedActivationFn =
    user.isLoggedIn() ? activateSavedPartners : ()=> {notifyMustLogInFn(beforeLogin)};


  return (
    <div className={computedClassName}>
      <FormsControlBar className="2xs:hidden" foundPartnerCount={foundPartnerCount} formToggleFn={toggleFilters}/>
      <nav className="flex flex-row items-center justify-between">
        <ul className="flex-grow flex items-center">
          <CCTab className="!pl-6 2xs:!px-4 flex-grow 2xs:flex-grow-0"
                 label={translatedAllResultsLabel}
                 tag="li"
                 exposure="low"
                 size={computedTabSize}
                 isActive={isFoundPartnersActive()}
                 activationFn={activateFoundPartners}/>
          <CCTab className="flex-grow 2xs:flex-grow-0"
                 label={`${translatedSavedLabel} (${userSavedPartners.length})`}
                 tag="li"
                 exposure="low"
                 size={computedTabSize}
                 isActive={isSavedPartnersActive()}
                 isDisabled={ isLoggedInUserFetchingInProgress || !!loggedInUserFetchingError }
                 activationFn={computedActivationFn}/>
          <CCTab className="flex-grow 2xs:flex-grow-0"
                 label={translatedMyPartnersLabel}
                 tag="li"
                 exposure="low"
                 size={computedTabSize}
                 isActive={isMyPartnersActive()}
                 isDisabled={ true }
                 activationFn={activateMyPartners}/>
        </ul>
        {
          isFoundPartnersActive() && isScreen2XSAndUp &&
          <SortingParameter className="mr-4"/>
        }
      </nav>
    </div>
  );
}

